export default "__VITE_ASSET__DN7eXogR__"